import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private header: HttpHeaders;
  private apiUrl: string;

  constructor(public http: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.prepareHeader();
  }

  private prepareHeader() {
    this.header = new HttpHeaders({});
  }

  private extractData(res: any) {
    try {
      return res || {};
    } catch (e) {
      return null;
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error);
    return throwError(error);
  }

  public get(endpoint: string, params = {}, id?: string): Observable<any> {
    return this.http
      .get(id ? `${this.apiUrl}${endpoint}${id}` : `${this.apiUrl}${endpoint}`, { headers: this.header, params })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public post(endpoint: string, postObject: any, contractName?: string, options?: any): Observable<any> {
    let param;
    if (contractName) {
      param = { contractType: contractName };
    }

    const config: any = {
      headers: this.header,
      params: param
    };

    if (options) {
      Object.assign(config, options);
    }

    return this.http
      .post(`${this.apiUrl}${endpoint}`, postObject, config)
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public postFilter(endpoint: string, params = {}, filter?: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${endpoint}`, filter, { headers: this.header, params })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public postTrack(endpoint: string, params = {}): Observable<any> {
    return this.http
      .post(`${this.apiUrl}${endpoint}`, null, { headers: this.header, params })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public postWithHeaders(endpoint: string, formData: any, header: any) {
    return this.http
      .post(`${this.apiUrl}${endpoint}`, formData, { headers: header ? header : this.header })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public putWithHeaders(endpoint: string, formData: any, header: any) {
    return this.http
      .put(`${this.apiUrl}${endpoint}`, formData, { headers: header ? header : this.header })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public put(endpoint: string, id: string | number, postObject: any, status?: any): Observable<any> {
    let params;
    if (status) {
      params = { status: status };
    }
    return this.http
      .put(`${this.apiUrl}${endpoint}`, postObject, { headers: this.header, params: params })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public delete(endpoint: string, id: string): Observable<any> {
    return this.http
      .delete(`${this.apiUrl}${endpoint}`, { headers: this.header })
      .pipe(map(this.extractData))
      .pipe(catchError(this.handleError));
  }

  public genericRequest(type: string, endpoint: string, data: any, header?: any): Observable<any> {
    let options = {
      body: data,
      headers: header ? header : this.header
    };
    return this.http.request(type, `${endpoint}`, options);
  }
}
